export default {
  videoWrapper: 'video-wrapper',
  VideoCard: {
    card: 'primary-card flex flex-wrap ie-primary-card',
    mediaWrapper: 'flex flex-col relative',
    cardMedia: 'w-full',
    contentWrapper: 'h-full',
    cardContent:
      'flex-grow flex-no-shrink flex-basis px-20 absolute left-0 right-0 bottom-0 text-center',
    cardActions: 'playButton-wrapper absolute m-0',
    header:
      'mt-20 md:mt-4 sm:mb-2 md:mb-10 font-BebasNeueRegular text-34 md:text-48 text-white',
    description:
      'mb-25 md:mb-50 font-BornreadyRegular text-36 md:text-52 text-white',
    componentBox: 'component-box w-full',
    button: ['btn btn-solid'],
    buttonContainer: 'w-full',
    videoWrapper: 'videoWrapper',
    thumbnailImage: 'thumbnailImage ie-video-thumbnail',
    playButton: 'playButton',
  },
  PowerOfHairVideoCard: {
    card: 'primary-card flex flex-wrap ie-primary-card pb-50 md:pb-70',
    mediaWrapper: 'flex flex-col relative',
    cardMedia: 'w-full',
    contentWrapper: 'h-full',
    cardContent:
      'flex-grow flex-no-shrink flex-basis px-20 absolute left-0 right-0 bottom-0 text-center',
    cardActions: 'playButton-wrapper absolute m-0',
    header:
      'mt-20 md:mt-4 sm:mb-2 md:mb-10 font-BebasNeueRegular text-24 md:text-48 text-white',
    description:
      'mb-10 md:mb-50 font-BornreadyRegular text-27 md:text-52 text-white',
    componentBox: 'component-box w-full',
    button: ['btn btn-solid'],
    buttonContainer: 'w-full',
    videoWrapper: 'videoWrapper',
    thumbnailImage: 'thumbnailImage ie-video-thumbnail',
    playButton: 'playButton',
  },
  VideoCarousel: {
    card: 'VideoCarousel primary-card flex flex-wrap ie-primary-card',
    mediaWrapper: 'flex flex-col relative mb-20 w-full',
    cardMedia: 'w-full',
    contentWrapper: 'h-full',
    cardContent:
      'flex-grow flex-no-shrink flex-basis sm:px-0 px-20 text-center w-full',
    cardActions: 'playButton-wrapper absolute m-0',
    header:
      'quotes-text hair-has-no-gender-quotes-text flex justify-center text-20 font-BebasNeueRegular md:font-HelveticaNeueMedium lg:w-5/9 mx-auto leading-28 sm:pl-70 sm:pr-20 lg:px-20 sm:text-left lg:text-center mt-30 mb-24',
    description: 'font-sans-light text-black text-s18-m20-l24 mb-25 md:mb-20',
    componentBox: 'component-box w-full',
    button: ['btn btn-solid'],
    buttonContainer: 'w-full',
    videoWrapper: 'videoWrapper',
    thumbnailImage: 'thumbnailImage',
    playButton: 'playButton',
  },
  cabeloVideoCard: {
    card: 'primary-card flex flex-wrap ie-primary-card px-30 md:px-0',
    mediaWrapper: 'flex flex-col relative',
    cardMedia: 'w-full',
    contentWrapper: 'h-full',
    cardContent:
      'flex-grow flex-no-shrink flex-basis px-20 absolute left-0 right-0 bottom-0 text-center',
    cardActions: 'playButton-wrapper absolute m-0',
    header:
      'mt-20 md:mt-4 sm:mb-10 md:mb-20 font-BebasNeueRegular text-34 md:text-48 text-white',
    description:
      'mb-25 md:mb-50 font-BornreadyRegular text-36 md:text-52 text-white',
    componentBox: 'component-box w-full',
    button: ['btn btn-solid'],
    buttonContainer: 'w-full',
    videoWrapper: 'videoWrapper',
    thumbnailImage: 'thumbnailImage ie-video-thumbnail',
    playButton: 'playButton',
  },
  campaignSubVideoCard: {
    card: 'primary-card flex flex-wrap ie-primary-card',
    mediaWrapper: 'flex flex-col relative',
    cardMedia: 'w-full',
    contentWrapper: 'h-full',
    cardContent:
      'flex-grow flex-no-shrink flex-basis px-20 absolute left-0 right-0 bottom-0 text-center',
    cardActions: 'playButton-wrapper absolute m-0',
    header:
      'mt-20 md:mt-4 sm:mb-20 mdp:mb-30 md:mb-30 font-BebasNeueRegular text-34 md:text-40 md:text-48 text-white',
    description:
      'mb-25 md:mb-50 font-BornreadyRegular text-36 md:text-52 text-white',
    componentBox: 'component-box w-full',
    button: ['btn btn-solid'],
    buttonContainer: 'w-full',
    videoWrapper: 'videoWrapper campaignSubVdo',
    thumbnailImage: 'thumbnailImage ie-video-thumbnail',
    playButton: 'playButton',
  },
};
